var md5 = require("./md5");
var CryptoJS = require("./crypto");
var xml2json = require("./xml2json");
var json2xml = require("./json2xml");
// import Buffer from "buffer";
// var Buffer = require("buffer/").Buffer;

function camSafeUrlEncode(str) {
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A");
}

function getObjectKeys(obj, forKey) {
  var list = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      list.push(forKey ? camSafeUrlEncode(key).toLowerCase() : key);
    }
  }
  return list.sort(function (a, b) {
    a = a.toLowerCase();
    b = b.toLowerCase();
    return a === b ? 0 : a > b ? 1 : -1;
  });
}

function map(obj, fn) {
  var o = isArray(obj) ? [] : {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = fn(obj[i], i);
    }
  }
  return o;
}

var obj2str = function (obj, lowerCaseKey) {
  var i, key, val;
  var list = [];
  var keyList = getObjectKeys(obj);
  for (i = 0; i < keyList.length; i++) {
    key = keyList[i];
    val = obj[key] === undefined || obj[key] === null ? "" : "" + obj[key];
    key = lowerCaseKey
      ? camSafeUrlEncode(key).toLowerCase()
      : camSafeUrlEncode(key);
    val = camSafeUrlEncode(val) || "";
    list.push(key + "=" + val);
  }
  return list.join("&");
};
// 可以签入签名的headers
var signHeaders = [
  "content-disposition",
  "content-encoding",
  "content-length",
  "content-md5",
  "expect",
  "host",
  "if-match",
  "if-modified-since",
  "if-none-match",
  "if-unmodified-since",
  "origin",
  "range",
  "response-cache-control",
  "response-content-disposition",
  "response-content-encoding",
  "response-content-language",
  "response-content-type",
  "response-expires",
  "transfer-encoding",
  "versionid",
];

var getSignHeaderObj = function (headers) {
  var signHeaderObj = {};
  for (var i in headers) {
    var key = i.toLowerCase();
    if (key.indexOf("x-cos-") > -1 || signHeaders.indexOf(key) > -1) {
      signHeaderObj[i] = headers[i];
    }
  }
  return signHeaderObj;
};

function clone(obj) {
  return map(obj, function (v) {
    return typeof v === "object" && v !== null ? clone(v) : v;
  });
}

// 获取调正的时间戳
var getSkewTime = function (offset) {
  return Date.now() + (offset || 0);
};

//测试用的key后面可以去掉
export function getAuth(opt) {
  opt = opt || {};
  var SecretId = opt.SecretId;
  // SecretId =
  //   "AKIDxOlWkBRNBZpEwwF0V1XIimBQUKgk5Rpp5E7Ibmyoq-Gga6SIKt_MqugFd6SjDoPp";
  var SecretKey = opt.SecretKey;
  // SecretKey = "5Yr2BjI+wAzxkiUGtNgpZL0BkVdTbmcYy0FwShnOc1U=";
  var KeyTime = opt.KeyTime;
  // KeyTime = "1666661708;1666668908";
  var method = (opt.method || opt.Method || "get").toLowerCase();
  // method = "get";
  // var queryParams = clone(opt.Query || opt.params || {});
  var queryParams = {};
  // var headers = getSignHeaderObj(clone(opt.Headers || opt.headers || {}));
  var headers = {};
  var Key = opt.Key || "";
  var pathname;
  pathname = opt.pathName;
  // if (opt.UseRawKey) {
  //   pathname = opt.Pathname || opt.pathname || "/" + Key;
  // } else {
  //   pathname = opt.Pathname || opt.pathname || Key;
  //   pathname.indexOf("/") !== 0 && (pathname = "/" + pathname);
  // }
  // pathname = "/saas/image/2022-10/e78f59cb-7db9-4393-b93d-c959475a9f62.jPg";
  // ForceSignHost明确传入false才不加入host签名
  var forceSignHost = opt.ForceSignHost === false ? false : true;

  // 如果有传入存储桶且需要强制签名，那么签名默认加 Host 参与计算，避免跨桶访问
  // if (
  //   !headers.Host &&
  //   !headers.host &&
  //   opt.Bucket &&
  //   opt.Region &&
  //   forceSignHost
  // )
  //   headers.Host = opt.Bucket + ".cos." + opt.Region + ".myqcloud.com";

  if (!SecretId) throw new Error("missing param SecretId");
  if (!SecretKey) throw new Error("missing param SecretKey");

  // 签名有效起止时间
  var now = Math.round(getSkewTime(opt.SystemClockOffset) / 1000) - 1;
  var exp = now;

  var Expires = opt.Expires || opt.expires;
  if (Expires === undefined) {
    exp += 900; // 签名过期时间为当前 + 900s
  } else {
    exp += Expires * 1 || 0;
  }
  console.log(2);
  // 要用到的 Authorization 参数列表
  var qSignAlgorithm = "sha1";
  var qAk = SecretId;
  var qSignTime = KeyTime || now + ";" + exp;
  var qKeyTime = KeyTime || now + ";" + exp;
  // var qHeaderList = getObjectKeys(headers, true).join(";").toLowerCase();
  var qHeaderList = "";
  var qUrlParamList = getObjectKeys(queryParams, true).join(";").toLowerCase();
  qUrlParamList = "";

  // 签名算法说明文档：https://www.qcloud.com/document/product/436/7778
  // 步骤一：计算 SignKey
  var signKey = CryptoJS.HmacSHA1(qKeyTime, SecretKey).toString();
  // 步骤二：构成 FormatString
  var formatString = [method, pathname, "", "", ""].join("\n");
  // formatString = Buffer.from(formatString, "utf8");
  // console.log("测试加密", formatString, CryptoJS.SHA1(formatString), "完毕");
  // formatString = String.raw`${method}\n${pathname}\n\n\n`;
  // console.log("测试", String.raw`get\n`);
  // console.log(method + "" + "\\n" + pathname + "\\n" + "\\n" + "\\n");
  // 步骤三：计算 StringToSign
  var stringToSign = [
    "sha1",
    qSignTime,
    CryptoJS.SHA1(formatString).toString(),
    "",
  ].join("\n");

  // stringToSign = String.raw`sha1\n${qSignTime}\n${CryptoJS.SHA1(
  //   formatString
  // ).toString()}\n`;
  // 步骤四：计算 Signature
  var qSignature = CryptoJS.HmacSHA1(stringToSign, signKey).toString();
  // 步骤五：构造 Authorization
  var authorization = [
    "q-sign-algorithm=" + qSignAlgorithm,
    "q-ak=" + qAk,
    "q-sign-time=" + qSignTime,
    "q-key-time=" + qKeyTime,
    "q-header-list=" + qHeaderList,
    "q-url-param-list=" + qUrlParamList,
    "q-signature=" + qSignature,
  ].join("&");
  console.log("authorization", authorization);
  return authorization;
}

export function test() {
  console.log("CryptoJS", CryptoJS);
}
